import React, { useEffect, useState } from "react";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import "../PublishAd/PublishAd.css";
import "./Profile.css";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

import axios from "axios";
import {
  storeUserIdentifies,
  updateUserIdentifies,
  clearState,
} from "../../redux/Slices/UserIdentifiesSlice";
const Profile = () => {
  const { t, i18n } = useTranslation("global");
  const user = JSON.parse(sessionStorage.getItem("user3ayin"));
  const userID = user?.user?.id;
  const [previewImage, setPreviewImage] = useState("./camera.png");
  const [isLoadingUpdate, setIsLoadingUpdate] = useState(false);
  const dispatch = useDispatch();

  const {
    success,
    error,
    successUpdate,
    errorUpdate,
    isLoading: loading,
  } = useSelector((state) => state.userIdentifies);


  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
      if (!allowedTypes.includes(file.type)) {
        toast.error(`${t("only_allowed")} JPG, JPEG, and PNG`);
        e.target.value = "";
        return;
      }

      setPreviewImage(URL.createObjectURL(file));
      setProfileData((prev) => ({
        ...prev,
        image: file,
      }));
    }
  };

  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const userData = JSON.parse(sessionStorage.getItem("user3ayin"));
  const token = userData?.token;
  const userType = userData?.user?.type;
  const [hasIdentifiers, setHasIdentifiers] = useState(false);
  const [profileData, setProfileData] = useState({
    name: "",
    phone: "",
    image: null,
    individual_type: null,
    email: "",
    username: "",
    company_type: null,
  });

  const [userIdentifiesFields, setUserIdentifiesFields] = useState({
    national_id_number: "",
    personal_photo: "",
    national_id_front: "",
    national_id_back: "",
    engineer_card_front: "",
    engineer_card_back: "",
    tax_number: "",
    company_logo: "",
    tax_record_front: "",
    tax_record_back: "",
    tax_card_front: "",
    tax_card_back: "",
    manager_name: "",
    company_name: "",
    address: "",
    manager_phone: "",
    manager_email: "",
    website_url: "",
    bio: "",
    previews: {},
  });

  const individualFieldConfig = {
    marketer: [
      { name: "national_id_number", type: "text", label: t("profile.nationalId"), required: true },
      { name: "national_id_front", type: "file", label: t("profile.idFront"), accept: "image/jpeg,image/jpg,image/png", required: true },
      { name: "national_id_back", type: "file", label: t("profile.idBack"), accept: "image/jpeg,image/jpg,image/png", required: true },
      { name: "has_marketing_experience", type: "checkbox", label: t("profile.has_marketing_experience"), required: false },
    ],
    engineer: [
      { name: "syndicate_card", type: "file", label: t("profile.syndicate_card"), accept: "image/jpeg,image/jpg,image/png", required: true },
      { name: "specialization", type: "text", label: t("profile.specialization"), required: true },
      { name: "experience_years", type: "text", label: t("profile.experience_years"), required: true },
      { name: "portfolio_link", type: "text", label: t("profile.portfolio_link"), required: false },
      { name: "cv_file", type: "file", label: t("profile.cv_file"), accept: ".pdf", required: true },
    ],
    instructor: [
      { name: "qualification", type: "text", label: t("profile.qualification"), required: true },
      { name: "job_title", type: "text", label: t("profile.job_title"), required: true },
      { name: "specialization", type: "text", label: t("profile.specialization"), required: true },
      { name: "cv_file", type: "file", label: t("profile.cv_file"), accept: ".pdf", required: true },
      { name: "demo_video_link", type: "text", label: t("profile.demo_video_link"), required: false },
    ],
  };

  const companyFieldConfig = {
    real_estate: [
      { name: "tax_number", type: "text", label: t("profile.tax_number"), required: true },
      { name: "commercial_record_number", type: "text", label: t("profile.commercial_record_number"), required: true },
      { name: "company_logo", type: "file", label: t("profile.company_logo"), accept: "image/jpeg,image/jpg,image/png", required: true },
      { name: "commercial_record_file", type: "file", label: t("profile.commercial_record_file"), accept: "image/jpeg,image/jpg,image/png", required: true },
      { name: "tax_card_file", type: "file", label: t("profile.tax_card_file"), accept: "image/jpeg,image/jpg,image/png", required: true },
      { name: "description", type: "textarea", label: t("profile.description"), required: true },
      { name: "facebook_url", type: "text", label: t("profile.facebook_url"), required: false },
      { name: "x_url", type: "text", label: t("profile.x_url"), required: false },
      { name: "instagram_url", type: "text", label: t("profile.instagram_url"), required: false },
      { name: "linkedin_url", type: "text", label: t("profile.linkedin_url"), required: false },
    ],
    engineering: [
      { name: "syndicate_license_number", type: "text", label: t("profile.syndicate_license_number"), required: true },
      { name: "company_logo", type: "file", label: t("profile.company_logo"), accept: "image/jpeg,image/jpg,image/png", required: true },
      { name: "commercial_record_file", type: "file", label: t("profile.commercial_record_file"), accept: "image/jpeg,image/jpg,image/png", required: true },
    ],
    educational: [
      { name: "education_license_file", type: "file", label: t("profile.education_license_file"), accept: "image/jpeg,image/jpg,image/png,.pdf", required: true },
      { name: "training_fields", type: "text", label: t("profile.training_fields"), required: true },
    ],
    tech: [
      { name: "product_name", type: "text", label: t("profile.product_name"), required: true },
      { name: "tech_solution_type", type: "text", label: t("profile.tech_solution_type"), required: true },
      { name: "tech_features", type: "textarea", label: t("profile.tech_features"), required: true },
    ],
  };
  const individualTypes = ["client", "marketer", "engineer", "instructor"];
  const companyTypes = ["real_estate", "engineering", "educational", "tech"];

  const individualTypeOptions = individualTypes.map((type) => ({
    value: type,
    label: t(`jobTitles.${type}`),
  }));

  const companyTypeOptions = companyTypes.map((type) => ({
    value: type,
    label: t(`companyTypes.${type}`),
  }));
  const handleSelectChange = (name, selectedOption) => {
    setProfileData((prev) => ({
      ...prev,
      [name]: selectedOption?.value || "",
    }));
  };
  const handleInputChange = (e) => {
    const { name, type, value, files, checked } = e.target;

    if (type === "file") {
      const file = files[0];
      if (!file) return;


      const field = [
        ...(individualFieldConfig[profileData.individual_type] || []),
        ...(companyFieldConfig[profileData.company_type] || []),
      ].find((f) => f.name === name);
      const allowedTypes = field?.accept?.split(",") || [];
      const isValid = allowedTypes.some((typeOrExt) => {
        typeOrExt = typeOrExt.trim();
        if (typeOrExt.startsWith("image")) {
          return file.type.startsWith("image");
        }
        if (typeOrExt === ".pdf") {
          return file.type === "application/pdf" || file.name.endsWith(".pdf");
        }
        return false;
      });

      if (!isValid) {
        toast.error(`${t("only_allowed")} ${field?.accept}`);
        e.target.value = "";
        return;
      }
      let previewUrl = null;

      if (file.type.startsWith("image")) {
        previewUrl = URL.createObjectURL(file);
      } else if (file.type === "application/pdf" || file.name.endsWith(".pdf")) {
        previewUrl = "/pdf.png";
      } else {
        previewUrl = "/file.png";
      }

      setUserIdentifiesFields((prev) => ({
        ...prev,
        [name]: file,
        previews: {
          ...prev.previews,
          [name]: previewUrl,
        },
      }));
    } else if (type === "checkbox") {
      setUserIdentifiesFields((prev) => ({
        ...prev,
        [name]: checked,
      }));
    } else {
      setUserIdentifiesFields((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };
  const handleRemoveFile = (fieldName) => {
    setUserIdentifiesFields((prev) => ({
      ...prev,
      [fieldName]: "",
      previews: {
        ...prev.previews,
        [fieldName]: null,
      },
    }));

    const input = document.querySelector(`input[name="${fieldName}"]`);
    if (input) {
      input.value = "";
    }
  };
  const urlFields = [
    "facebook_url",
    "x_url",
    "instagram_url",
    "linkedin_url",
    "website_url",
    "portfolio_link",
    "demo_video_link"
  ];
  const isValidUrl = (url) => {
    if (!url) return true;
    try {
      new URL(url);
      return true;
    } catch {
      return false;
    }
  };
  const basicCompanyLabels = {
    manager_name: t("profile.manager_name"),
    company_name: t("profile.company_name"),
    manager_phone: t("profile.manager_phone"),
    manager_email: t("profile.manager_email"),
    address: t("profile.address"),
    bio: t("profile.bio"),
    website_url: t("profile.website_url")
  };
  const handleUserIdentifiesSubmit = async (e, isUpdate = false) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("type", userType);

    let requiredFields = [];

    if (userType === "individual") {
      const subtype = profileData.individual_type;

      requiredFields.push("bio");
      formData.append("bio", userIdentifiesFields.bio);

      if (subtype === "marketer") {
        requiredFields.push(
          "national_id_number",
          "national_id_front",
          "national_id_back"
        );

        formData.append("national_id_number", userIdentifiesFields.national_id_number);
        ["national_id_front", "national_id_back"].forEach((field) => {
          if (userIdentifiesFields[field] instanceof File) {
            formData.append(field, userIdentifiesFields[field]);
          }
        });
        formData.append("has_marketing_experience", userIdentifiesFields.has_marketing_experience ? 1 : 0);
      }

      if (subtype === "engineer") {
        requiredFields.push(
          "syndicate_card",
          "specialization",
          "experience_years",
          "cv_file"
        );

        if (userIdentifiesFields.syndicate_card instanceof File) {
          formData.append("syndicate_card", userIdentifiesFields.syndicate_card);
        }
        formData.append("specialization", userIdentifiesFields.specialization);
        formData.append("experience_years", userIdentifiesFields.experience_years);
        formData.append("portfolio_link", userIdentifiesFields.portfolio_link);
        if (userIdentifiesFields.cv_file instanceof File) {
          formData.append("cv_file", userIdentifiesFields.cv_file);
        }
      }

      if (subtype === "instructor") {
        requiredFields.push(
          "qualification",
          "job_title",
          "specialization",
          "cv_file"
        );

        formData.append("qualification", userIdentifiesFields.qualification);
        formData.append("job_title", userIdentifiesFields.job_title);
        formData.append("specialization", userIdentifiesFields.specialization);
        if (userIdentifiesFields.cv_file instanceof File) {
          formData.append("cv_file", userIdentifiesFields.cv_file);
        }
        formData.append("demo_video_link", userIdentifiesFields.demo_video_link);
      }
    }

    if (userType === "company") {
      const subtype = profileData.company_type;

      requiredFields = [
        "address",
        "bio",
        "company_name",
        "manager_name",
        "manager_phone",
        "manager_email"
      ];

      formData.append("address", userIdentifiesFields.address);
      formData.append("company_name", userIdentifiesFields.company_name);
      formData.append("manager_name", userIdentifiesFields.manager_name);
      formData.append("manager_phone", userIdentifiesFields.manager_phone);
      formData.append("manager_email", userIdentifiesFields.manager_email);
      formData.append("bio", userIdentifiesFields.bio);
      formData.append("website_url", userIdentifiesFields.website_url);

      if (subtype === "real_estate") {
        requiredFields.push(
          "tax_number",
          "commercial_record_number",
          "company_logo",
          "commercial_record_file",
          "tax_card_file",
          "description"
        );

        formData.append("tax_number", userIdentifiesFields.tax_number);
        formData.append("commercial_record_number", userIdentifiesFields.commercial_record_number);
        ["company_logo", "commercial_record_file", "tax_card_file"].forEach((field) => {
          if (userIdentifiesFields[field] instanceof File) {
            formData.append(field, userIdentifiesFields[field]);
          }
        });
        formData.append("description", userIdentifiesFields.description);
        formData.append("facebook_url", userIdentifiesFields.facebook_url);
        formData.append("x_url", userIdentifiesFields.x_url);
        formData.append("instagram_url", userIdentifiesFields.instagram_url);
        formData.append("linkedin_url", userIdentifiesFields.linkedin_url);
      }

      if (subtype === "engineering") {
        requiredFields.push("syndicate_license_number", "company_logo", "commercial_record_file");

        formData.append("syndicate_license_number", userIdentifiesFields.syndicate_license_number);
        ["company_logo", "commercial_record_file"].forEach((field) => {
          if (userIdentifiesFields[field] instanceof File) {
            formData.append(field, userIdentifiesFields[field]);
          }
        });
      }

      if (subtype === "educational") {
        requiredFields.push("education_license_file", "training_fields");

        formData.append("education_license_file", userIdentifiesFields.education_license_file);
        formData.append("training_fields", userIdentifiesFields.training_fields);
      }

      if (subtype === "tech") {
        requiredFields.push("product_name", "tech_solution_type", "tech_features");

        formData.append("product_name", userIdentifiesFields.product_name);
        formData.append("tech_solution_type", userIdentifiesFields.tech_solution_type);
        formData.append("tech_features", userIdentifiesFields.tech_features);
      }
    }
    const emptyFields = requiredFields.filter((field) => {
      const value =
        userIdentifiesFields[field] !== undefined
          ? userIdentifiesFields[field]
          : profileData[field];

      // file fields
      const isFileField =
        value instanceof File ||
        field.includes("_file") ||
        field.includes("_logo") ||
        field.includes("_card") ||
        field.includes("_front") ||
        field.includes("_back");
      if (isFileField) {
        return !value && !userIdentifiesFields.previews[field];
      }

      return value === undefined || value === null || value === "";
    });

    const emptyFieldLabels = emptyFields.map((field) => {
      const individualFields = [
        ...(individualFieldConfig[profileData.individual_type] || []),
      ];
      const companyFields = [
        ...(companyFieldConfig[profileData.company_type] || []),
      ];

      const found =
        individualFields.find((f) => f.name === field) ||
        companyFields.find((f) => f.name === field);

      return found?.label || basicCompanyLabels[field] || field;
    });


    if (emptyFields.length > 0) {
      toast.error(`${t("profile.please_fill_mandatory_fields")}: ${emptyFieldLabels.join(", ")}`);
      return;
    }

    if (userIdentifiesFields.national_id_number) {
      const nationalId = userIdentifiesFields.national_id_number.toString().trim();

      if (!/^\d{14}$/.test(nationalId)) {
        toast.error(
          i18n.language === "ar"
            ? "الرقم القومي يجب أن يكون 14 رقم"
            : "National ID must be 14 digits"
        );
        return;
      }
    }

    const invalidUrl = urlFields.some((field) => {
      const value = userIdentifiesFields[field];

      if (!value) return false;
      return !isValidUrl(value);
    });

    if (invalidUrl) {
      toast.error(
        i18n.language === "ar"
          ? "يرجى إدخال روابط صحيحة"
          : "Please enter valid URLs"
      );
      return;
    }

    urlFields.forEach((field) => {
      const value = userIdentifiesFields[field];
      if (value) {
        formData.append(field, value);
      }
    });

    if (isUpdate) {
      try {
        await dispatch(updateUserIdentifies(formData)).unwrap();
        window.location.reload();
      } catch (error) {
        console.log(error);
      }
    } else {
      try {
        await dispatch(storeUserIdentifies(formData)).unwrap();
        window.location.reload();
      } catch (error) {
        console.log(error);
      }
    }
  };
  // fetch identifiers
  const getUserIdentifiers = async () => {
    try {
      const token = JSON.parse(sessionStorage.getItem("user3ayin"))?.token;
      const { data } = await axios.get(
        `https://app.xn--mgb9a0bp.com/api/profile/identifies`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            Lang: i18n.language,
          },
        }
      );

      if (data?.code === 200) {
        const identifiers = data.data;

        setUserIdentifiesFields((prev) => ({
          ...prev,
          ...identifiers,
          national_id_number: identifiers.national_id_number || "",
          personal_photo: identifiers.personal_photo,
          national_id_front: identifiers.national_id_front,
          national_id_back: identifiers.national_id_back,
          tax_number: identifiers.tax_number || "",
          company_logo: identifiers.company_logo,
          tax_record_front: identifiers.tax_record_front,
          tax_record_back: identifiers.tax_record_back,
          tax_card_front: identifiers.tax_card_front,
          tax_card_back: identifiers.tax_card_back,
          commercial_record_file: identifiers.commercial_record_file,
          tax_card_file: identifiers.tax_card_file,
          syndicate_card: identifiers.syndicate_card,
          cv_file: identifiers.cv_file,
          education_license_file: identifiers.education_license_file,
          previews: {
            personal_photo: identifiers.personal_photo,
            national_id_front: identifiers.national_id_front,
            national_id_back: identifiers.national_id_back,
            company_logo: identifiers.company_logo,
            tax_record_front: identifiers.tax_record_front,
            tax_record_back: identifiers.tax_record_back,
            tax_card_front: identifiers.tax_card_front,
            tax_card_back: identifiers.tax_card_back,
            commercial_record_file: identifiers.commercial_record_file,
            tax_card_file: identifiers.tax_card_file,
            syndicate_card: identifiers.syndicate_card,
            cv_file: identifiers.cv_file,
            education_license_file: identifiers.education_license_file,
          },
        }));
        setHasIdentifiers(true);
      } else {
        setHasIdentifiers(false);
      }
    } catch (error) {
      console.error("Error fetching identifiers:", error);
    }
  };

  useEffect(() => {
    getUserIdentifiers();
  }, [i18n.language]);
  useEffect(() => {
    if (success) {
      toast.success(t("addedSuccessfully"));
      dispatch(clearState());
    }
    if (error) {
      toast.error(t("failedToAdd"));
      dispatch(clearState());
    }
  }, [success, error]);
  useEffect(() => {
    if (successUpdate) {
      toast.success(t("updatedSuccessfully"));
      dispatch(clearState());
    }
    if (errorUpdate) {
      toast.error(t("failedToUpdate"));
      dispatch(clearState());
    }
  }, [successUpdate, errorUpdate]);

  // handle profile change
  const handleProfileChange = (e) => {
    const { name, value } = e.target;
    setProfileData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const getProfileData = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/api/profileData`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
          Lang: i18n.language,
        },
      });

      const user = response.data.data?.user;
      if (!user) return;

      const profile = user.profile || {};

      const type = user.type;
      const individual_type = profile.individual_type;
      const company_type = profile.company_type;

      const baseData = {
        name: profile.name || "",
        phone: user.phone || "",
        email: user.email || "",
        image: user.image || null,
        username: profile.username || ""
      };

      setProfileData((prev) => ({
        ...prev,
        ...baseData,
        individual_type: individual_type || "",
        company_type: company_type || "",
      }));

      if (type === "individual" && individual_type) {
        const selectedJob = individualTypeOptions.find(
          (opt) => opt.value === individual_type
        );
        if (selectedJob) {
          setProfileData((prev) => ({
            ...prev,
            individual_type: selectedJob.value,
          }));
        }
      }

      if (type === "company" && company_type) {
        const selectedCompanyType = companyTypeOptions.find(
          (opt) => opt.value === company_type
        );
        if (selectedCompanyType) {
          setProfileData((prev) => ({
            ...prev,
            company_type: selectedCompanyType.value,
          }));
        }
      }

      // preview image 
      if (user.image) setPreviewImage(user.image);

    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    getProfileData();
  }, []);


  // submit update profile
  const handleSubmit = (e) => {
    e.preventDefault();

    if (!profileData.phone || profileData.phone.length < 11 || profileData.phone.length > 11) {
      toast.error(t("validation.the_phone_field_must_be_at_least_11_characters"));
      return;
    }

    const formData = new FormData();
    formData.append("phone", profileData.phone);
    formData.append("email", profileData.email);

    if (profileData.image && profileData.image instanceof File) {
      formData.append("image", profileData.image);
    }

    if (userType === "company") {
      formData.append(
        "company_type",
        profileData.company_type?.value ?? ""
      );
      formData.append("username", profileData.username);
    }

    if (userType === "individual") {
      formData.append("name", profileData.name);
      formData.append("individual_type", profileData.individual_type?.value ?? "");
    }

    setIsLoadingUpdate(true);
    axios
      .post(`${BASE_URL}/api/profile/update`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
          Lang: i18n.language,
        },
      })
      .then((res) => {
        toast.success(t("profile.updatedSuccessfully"));
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      })
      .catch(() => {
        setIsLoadingUpdate(false);
        toast.error(t("profile.updateFailed"));
      })
      .finally(() => {
        setIsLoadingUpdate(false);
      });
  };

  return (
    <>
      <Breadcrumb title={t("profile.title")} />
      <div className="profile py-5 bg_overlay">
        <div className="container position-relative">
          <ul
            className="nav nav-tabs justify-content-center"
            id="myTab"
            role="tablist"
          >
            <li className="nav-item" role="presentation">
              <button
                className="nav-link active"
                id="profile-tab"
                data-bs-toggle="tab"
                data-bs-target="#profile"
                type="button"
                role="tab"
                aria-controls="profile"
                aria-selected="true"
              >
                {t("profile.title")}
              </button>
            </li>
            {userData?.user?.profile?.individual_type !== "client" && (
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="identityVerification-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#identityVerification"
                  type="button"
                  role="tab"
                  aria-controls="identityVerification"
                  aria-selected="false"
                >
                  {t("profile.identityVerification")}
                </button>
              </li>
            )}

          </ul>
          <div className="tab-content" id="myTabContent">
            <div
              className="tab-pane fade show active p-3"
              id="profile"
              role="tabpanel"
              aria-labelledby="profile-tab"
            >
              <form className="form-style" onSubmit={handleSubmit}>
                <div className="row">
                  {/* Upload Image */}
                  <div className="col-12">
                    <div className="user_upload_profile">
                      <input
                        type="file"
                        accept=".jpg, .jpeg, .png"
                        name="image"
                        onChange={handleImageChange}
                      />
                      <div className="img">
                        <img
                          src={previewImage || "./camera.png"}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = "./camera.png";
                          }}
                          alt="--"
                        />
                      </div>
                      <div className="icon">
                        <i className="bi bi-camera-fill"></i>
                      </div>
                    </div>
                  </div>

                  {userType === "individual" && (
                    <>
                      <div className="col-xl-6 col-lg-6 col-md-12 col-12">
                        <label>{t("profile.name")}</label>
                        <input
                          type="text"
                          required
                          name="name"
                          onChange={handleProfileChange}
                          value={profileData.name}
                          placeholder={t("profile.name")}
                        />
                      </div>

                    </>
                  )}
                  {userType === "company" && (
                    <>
                      <div className="col-xl-6 col-lg-6 col-md-12 col-12">
                        <label>{t("sign.account_username")}</label>
                        <input
                          type="text"
                          name="username"
                          onChange={handleProfileChange}
                          value={profileData.username}
                          placeholder={t("sign.account_username")}
                        />
                      </div>

                    </>
                  )}

                  <div className="col-xl-6 col-lg-6 col-md-12 col-12">
                    <label>{t("profile.email")}</label>
                    <input
                      type="text"
                      name="email"
                      disabled
                      readOnly
                      style={{ cursor: "no-drop" }}
                      className="bg-light"
                      value={profileData.email}
                      placeholder={t("profile.email")}
                    />
                  </div>

                  <div className="col-xl-6 col-lg-6 col-md-12 col-12">
                    <label>{t("profile.phone")}</label>
                    <input
                      type="number"
                      min="0"
                      onInput={(e) => {
                        e.target.value = e.target.value.replace(/[^0-9]/g, "");
                      }}
                      name="phone"
                      required
                      onChange={handleProfileChange}
                      value={profileData.phone}
                      placeholder={t("profile.phone")}
                    />
                  </div>

                  {userType === "individual" && (
                    <div className="col-xl-6 col-lg-6 col-md-12 col-12">
                      <label>{t("profile.jobTitle")}</label>
                      <Select
                        name="individual_type"
                        value={individualTypeOptions.find((opt) => opt.value === profileData.individual_type) || null}
                        onChange={(option) => handleSelectChange("individual_type", option)}
                        classNamePrefix="react-select"
                        options={individualTypeOptions}
                        placeholder={t("profile.jobTitle")}
                        isDisabled={true}
                      />
                    </div>
                  )}

                  {userType === "company" && (
                    <div className="col-xl-6 col-lg-6 col-md-12 col-12">
                      <label>{t("sign.company_type")}</label>
                      <Select
                        name="company_type"
                        value={companyTypeOptions.find((opt) => opt.value === profileData.company_type) || null}
                        onChange={(option) => handleSelectChange("company_type", option)}
                        classNamePrefix="react-select"
                        options={companyTypeOptions}
                        placeholder={t("sign.company_type")}
                        isDisabled={true}
                      />
                    </div>
                  )}

                  <div className="col-md-12">
                    <button
                      type="submit"
                      className="mt-3"
                      disabled={isLoadingUpdate}
                    >
                      {isLoadingUpdate ? (
                        t("loading")
                      ) : (
                        t("profile.save")
                      )}
                    </button>
                  </div>
                </div>
              </form>
            </div>
            {userData?.user?.profile?.individual_type !== "client" && (
              <div
                className="tab-pane fade p-3"
                id="identityVerification"
                role="tabpanel"
                aria-labelledby="identityVerification-tab"
              >
                <form onSubmit={(e) => handleUserIdentifiesSubmit(e, hasIdentifiers)}>
                  {userType === "individual" && (
                    <div className="form-style">
                      <h5 className="fw-bold mb-3">{t("profile.basic_information")}</h5>
                      <div className="row">
                        <div className="col-xl-6 col-lg-6 col-md-6 col-12">
                          <label>{t("profile.bio")} <sup className="text-danger">*</sup></label>
                          <textarea
                            name="bio"
                            type="text"
                            onChange={handleInputChange}
                            value={userIdentifiesFields.bio || ""}
                            placeholder={t("profile.bio")}
                          />
                        </div>
                      </div>
                      <hr />
                      <h5 className="fw-bold">{t("profile.identity_information")}</h5>

                      <div className="row">
                        {individualFieldConfig[profileData.individual_type]?.map((field) => (
                          <div className="col-xl-12 col-lg-12 col-md-12 col-12" key={field.name}>
                            <label>{field.label} {field.required && <sup className="text-danger">*</sup>}</label>

                            {field.type === "text" && (
                              <input
                                name={field.name}
                                onChange={handleInputChange}
                                value={userIdentifiesFields[field.name] || ""}
                                placeholder={field.label}
                              />
                            )}

                            {field.type === "textarea" && (
                              <textarea
                                name={field.name}
                                onChange={handleInputChange}
                                value={userIdentifiesFields[field.name] || ""}
                                placeholder={field.label}
                              />
                            )}

                            {field.type === "file" && (
                              <div className="photo_wrapper" style={{ position: "relative" }}>
                                <input
                                  type="file"
                                  accept={field.accept}
                                  name={field.name}
                                  onChange={handleInputChange}
                                />

                                {(() => {
                                  const preview = userIdentifiesFields.previews?.[field.name];

                                  if (!preview) {
                                    return <img src="/camera.png" alt="camera" />;
                                  }

                                  if (preview?.endsWith(".pdf")) {
                                    return <img src="/pdf.png" alt="pdf" />;
                                  }

                                  if (preview === "/file.png") {
                                    return <img src="/file.png" alt="file" />;
                                  }

                                  return <img src={preview} alt="preview" />;
                                })()}

                                {userIdentifiesFields.previews[field.name] && (
                                  <button
                                    type="button"
                                    onClick={() => handleRemoveFile(field.name)}
                                    style={{
                                      position: "absolute",
                                      top: "7px",
                                      right: "40%",
                                      backgroundColor: "#EF5350",
                                      color: "white",
                                      border: "none",
                                      borderRadius: "50%",
                                      width: "22px",
                                      height: "22px",
                                      fontSize: "small",
                                      cursor: "pointer",
                                      transform: "translateX(-40%)",
                                      padding: "0"
                                    }}
                                  >
                                    ×
                                  </button>
                                )}

                                <span>{t("create_ad.uploadSingleFile")}</span>
                              </div>
                            )}

                            {field.type === "checkbox" && (
                              <input
                                type="checkbox"
                                name={field.name}
                                className="no-class"
                                onChange={handleInputChange}
                                checked={!!userIdentifiesFields[field.name]}
                              />
                            )}
                          </div>
                        ))}
                      </div>

                      <br />
                      <button type="submit" disabled={loading}>
                        {loading
                          ? t("loading")
                          : hasIdentifiers
                            ? t("pages.update")
                            : t("pages.helpCenter.send")}
                      </button>
                    </div>
                  )}

                  {userType === "company" && (
                    <div className="form-style">
                      <h5 className="fw-bold mb-3">{t("profile.basic_information")}</h5>
                      <div className="row">
                        <div className="col-xl-6 col-lg-6 col-md-6 col-12">
                          <label>{t("profile.company_name")} <sup className="text-danger">*</sup></label>
                          <input
                            name="company_name"
                            type="text"
                            onChange={handleInputChange}
                            value={userIdentifiesFields.company_name || ""}
                            placeholder={t("profile.company_name")}
                          />
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-6 col-12">
                          <label>{t("profile.manager_name")} <sup className="text-danger">*</sup></label>
                          <input
                            name="manager_name"
                            type="text"
                            onChange={handleInputChange}
                            value={userIdentifiesFields.manager_name || ""}
                            placeholder={t("profile.manager_name")}
                          />
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-6 col-12">
                          <label>{t("profile.manager_phone")} <sup className="text-danger">*</sup></label>
                          <input
                            name="manager_phone"
                            type="text"
                            onChange={handleInputChange}
                            value={userIdentifiesFields.manager_phone || ""}
                            placeholder={t("profile.manager_phone")}
                          />
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-6 col-12">
                          <label>{t("profile.manager_email")} <sup className="text-danger">*</sup></label>
                          <input
                            name="manager_email"
                            type="email"
                            onChange={handleInputChange}
                            value={userIdentifiesFields.manager_email || ""}
                            placeholder={t("profile.manager_email")}
                          />
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-6 col-12">
                          <label>{t("profile.address")} <sup className="text-danger">*</sup></label>
                          <input
                            name="address"
                            type="text"
                            onChange={handleInputChange}
                            value={userIdentifiesFields.address || ""}
                            placeholder={t("profile.address")}
                          />
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-6 col-12">
                          <label>{t("profile.website_url")} </label>
                          <input
                            name="website_url"
                            type="text"
                            onChange={handleInputChange}
                            value={userIdentifiesFields.website_url || ""}
                            placeholder={t("profile.website_url")}
                          />
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-6 col-12">
                          <label>{t("profile.bio")} <sup className="text-danger">*</sup></label>
                          <textarea
                            name="bio"
                            type="text"
                            onChange={handleInputChange}
                            value={userIdentifiesFields.bio || ""}
                            placeholder={t("profile.bio")}
                          />
                        </div>
                      </div>
                      <hr />
                      <h5 className="fw-bold mb-3">{t("profile.company_information")}</h5>

                      <div className="row">
                        {companyFieldConfig[profileData.company_type]?.map((field) => (
                          <div className="col-xl-12 col-lg-12 col-md-12 col-12" key={field.name}>
                            <label>{field.label} {field.required && <sup className="text-danger">*</sup>}</label>

                            {field.type === "text" && (
                              <input
                                name={field.name}
                                onChange={handleInputChange}
                                value={userIdentifiesFields[field.name] || ""}
                                placeholder={field.label}
                              />
                            )}
                            {field.type === "textarea" && (
                              <textarea
                                name={field.name}
                                onChange={handleInputChange}
                                value={userIdentifiesFields[field.name] || ""}
                                placeholder={field.label}
                              />
                            )}

                            {field.type === "file" && (
                              <div className="photo_wrapper" style={{ position: "relative" }}>
                                <input
                                  type="file"
                                  accept={field.accept}
                                  name={field.name}
                                  onChange={handleInputChange}
                                />

                                {(() => {
                                  const preview = userIdentifiesFields.previews?.[field.name];

                                  if (!preview) {
                                    return <img src="/camera.png" alt="camera" />;
                                  }

                                  if (preview?.endsWith(".pdf")) {
                                    return <img src="/pdf.png" alt="pdf" />;
                                  }

                                  if (preview === "/file.png") {
                                    return <img src="/file.png" alt="file" />;
                                  }

                                  return <img src={preview} alt="preview" />;
                                })()}

                                {userIdentifiesFields.previews[field.name] && (
                                  <button
                                    type="button"
                                    onClick={() => handleRemoveFile(field.name)}
                                    style={{
                                      position: "absolute",
                                      top: "7px",
                                      right: "40%",
                                      backgroundColor: "#EF5350",
                                      color: "white",
                                      border: "none",
                                      borderRadius: "50%",
                                      width: "22px",
                                      height: "22px",
                                      fontSize: "small",
                                      cursor: "pointer",
                                      transform: "translateX(-40%)",
                                      padding: "0"
                                    }}
                                  >
                                    ×
                                  </button>
                                )}

                                <span>{t("create_ad.uploadSingleFile")}</span>
                              </div>
                            )}

                            {field.type === "checkbox" && (
                              <input
                                type="checkbox"
                                name={field.name}
                                className="no-class"
                                onChange={handleInputChange}
                                checked={!!userIdentifiesFields[field.name]}
                              />
                            )}
                          </div>
                        ))}
                      </div>
                      <br />
                      <button type="submit" disabled={loading}>
                        {loading
                          ? t("loading")
                          : hasIdentifiers
                            ? t("pages.update")
                            : t("pages.helpCenter.send")}
                      </button>
                    </div>
                  )}
                </form>
              </div>)}
          </div>
        </div>
      </div>
    </>
  );
};

export default Profile;